export const BASE_URL = process.env.NODE_ENV === "production" ? 'https://webapp.wine2trace.com/api' : 'http://localhost:3500/api';
